<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Editar registro</span>
  <button mat-icon-button (click)="cancelar()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col">
        <app-input class="w-100" inputType="time" placeholder="Hora entrada" formControlName="horaEntrada"></app-input>
      </div>
      <div class="col">
        <app-input class="w-100" inputType="time" placeholder="Hora salida" formControlName="horaSalida"></app-input>
      </div>
    </div>

    <mat-form-field class="w-100">
      <mat-label>Comentario</mat-label>
      <textarea matInput formControlName="comentario" rows="2"></textarea>
    </mat-form-field>

    <mat-form-field class="w-100">
      <textarea matInput placeholder="Motivo de la edición" formControlName="motivo" rows="3"></textarea>
      <mat-hint>Indica por qué se corrige este registro; queda guardado en el historial de auditoría</mat-hint>
      <mat-error *ngIf="form.controls['motivo'].hasError('required')">
        <small>El motivo es <strong>obligatorio</strong></small>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancelar()">
    <mat-icon>cancel</mat-icon>
    Cancelar
  </button>
  <button mat-stroked-button color="primary" [disabled]="!form.valid" (click)="guardar()" class="ms-2">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>
